import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ThemeSettings {
  for_color: string
  back_color: string
  brand_logo: string
  shield_logo: string
}

export interface EnvironmentSettings {
  mode: string
  layout: string
}

const initialState = {
  theme: {
    for_color: '',
    back_color: '',
    brand_logo: '',
    shield_logo: '',
  },
  environment: {
    mode: '',
    layout: '',
  },
}

const themeSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<ThemeSettings>) => {
      state.theme = { ...state.theme, ...action.payload }
    },
    setEnvironment: (state, action: PayloadAction<EnvironmentSettings>) => {
      state.environment = { ...state.environment, ...action.payload }
    },
  },
})

export const { setTheme, setEnvironment } = themeSlice.actions
export default themeSlice.reducer
